type RAGType = 'Red' | 'Amber' | 'Green' | 'Not Rated';

export function RAGBadge({ rag, size = 'md' }: { rag: RAGType; size?: 'sm' | 'md' }) {
  const styles: Record<RAGType, string> = {
    Green: 'bg-success-100 text-success-700 ring-success-600/20',
    Amber: 'bg-warning-100 text-warning-700 ring-warning-600/20',
    Red: 'bg-error-100 text-error-700 ring-error-600/20',
    'Not Rated': 'bg-slate-100 text-slate-500 ring-slate-400/20',
  };
  const dotStyles: Record<RAGType, string> = {
    Green: 'bg-success-500',
    Amber: 'bg-warning-500',
    Red: 'bg-error-500',
    'Not Rated': 'bg-slate-400',
  };
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ring-1 ring-inset ${sizeClasses} ${styles[rag]}`}
    >
      <span className={`h-2 w-2 rounded-full ${dotStyles[rag]}`} />
      {rag}
    </span>
  );
}

export function OnTrackBadge({ onTrack }: { onTrack: boolean }) {
  return onTrack ? (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-success-50 px-2.5 py-1 text-xs font-semibold text-success-700 ring-1 ring-inset ring-success-600/20">
      <span className="h-2 w-2 rounded-full bg-success-500" />
      On Track
    </span>
  ) : (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-error-50 px-2.5 py-1 text-xs font-semibold text-error-700 ring-1 ring-inset ring-error-600/20">
      <span className="h-2 w-2 rounded-full bg-error-500" />
      Off Track
    </span>
  );
}

export function StatusBadge({ status }: { status: 'Passed' | 'Pending' | 'Failed' }) {
  const styles = {
    Passed: 'bg-success-100 text-success-700 ring-success-600/20',
    Pending: 'bg-slate-100 text-slate-600 ring-slate-500/20',
    Failed: 'bg-error-100 text-error-700 ring-error-600/20',
  } as const;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${styles[status]}`}
    >
      {status}
    </span>
  );
}
